import { registerView, ViewComponent } from "@frui.ts/views";
import Button from "@edaz/edazkit/Button";
import { IconType } from "@edaz/edazkit/Icon";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Col, Row } from "react-bootstrap";
import ValidationSummaryViewModel from "viewModels/paymentValidation/validationSummaryViewModel";
import ChargeCard from "./chargeCard";
import ExemptionCard from "./exemptionCard";
import NoRegistrationCard from "./noRegistrationCard";

const ValidationSummaryView: ViewComponent<ValidationSummaryViewModel> = observer(({ vm }) => {
  const showBuyButton = vm.buyEnabled && !vm.upcomingCharges.length;

  return (
    <>
      <ExemptionCard vm={vm} />
      <NoRegistrationCard vm={vm} />
      {vm.validCharges.map((validCharge, index) => (
        <ChargeCard key={index} vm={vm} charge={validCharge} />
      ))}
      {vm.upcomingCharges.length > 0 && <h5 className="text-muted mt-5">{vm.translate("upcomingCharges")}</h5>}
      {vm.upcomingCharges.map((upcomingCharge, index) => (
        <ChargeCard key={index} vm={vm} charge={upcomingCharge} />
      ))}
      <Row>
        <Col sm={showBuyButton ? true : 6} lg={showBuyButton ? 12 : "auto"} xl={showBuyButton ? true : 6}>
          <Button onClick={vm.next} className={"d-block mt-2 white-space-wrap-lg white-space-nowrap-xl "} block={true}>
            {vm.translate("next")}
          </Button>
        </Col>
        {showBuyButton && (
          <Col sm={true}>
            <Button iconLeft={IconType.ShoppingCart} iconLeftAlign={"right"} onClick={vm.buy} className={"d-block mt-2"} block>
              {vm.translate("buy")}
            </Button>
          </Col>
        )}
      </Row>
    </>
  );
});

registerView(ValidationSummaryView, ValidationSummaryViewModel);
